import React, { useState } from "react";
import { Introduction } from "./Sections/Introduction";
import { Navbar } from "./Components/Navbar";
import { ProfileSection } from "./Sections/ProfileSection";
import { WorkSection } from "./Sections/WorkSection";
import { Footer } from "./Components/Footer";

export function App() {
	return (
		<div className="container">
			<Navbar />
			<Introduction />
			<ProfileSection />
			<WorkSection />
			<Footer />
		</div>
	);
}

export default App;